import type * as type from "@vTypes";

function ConfSection_law({
  max_conseq_work,
  banned_day_after_eve,
  three_seq_nig,
  two_offs_after_three_nig,
  two_offs_after_two_nig,
  max_nig_per_month,

  setCurrentConfigures,
}: {
  max_conseq_work: number;
  banned_day_after_eve: boolean;
  three_seq_nig: boolean;
  two_offs_after_three_nig: boolean;
  two_offs_after_two_nig: boolean;
  max_nig_per_month: number;
  setCurrentConfigures: React.Dispatch<React.SetStateAction<type.ConfigObject>>;
}) {
  return (
    <div className="conf_schedule__itemWrap w-[395px]">
      <h2 className="conf_schedule__title">법정 기준 설정</h2>
      <div className="conf_schedule__table">
        <div className="conf_schedule__row conf_schedule__gridRow--switch">
          <div className="conf_schedule__optText">
            연속 근무일 수 최대 5일 이하
          </div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={max_conseq_work === 5}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                const newValue = isChecked ? 5 : 6;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  max_conseq_work: newValue,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        <div className="conf_schedule__row conf_schedule__gridRow--switch">
          <div className="conf_schedule__optText">
            ND/ED/NE 근무 패턴 불가능
          </div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={banned_day_after_eve}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  banned_day_after_eve: isChecked,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        <div className="conf_schedule__row conf_schedule__gridRow--switch">
          <div className="conf_schedule__optText">
            나이트 연속 근무 최대 3일 허용
            <span className="conf_schedule__optText--small">
              *적용 안 할 경우 나이트 연속 근무 최대 2일
            </span>
          </div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={three_seq_nig}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                // 요구사항 정리:
                // - three_seq_nig 값이 변경되면 two_offs_after_two_nig / two_offs_after_three_nig 는 무조건 false로 초기화
                // - two_offs_after_two_nig(2N OFF)는 two_offs_after_three_nig(3N OFF) 값에 종속
                // - two_offs_after_three_nig(3N OFF)는 two_offs_after_two_nig(2N OFF)에 종속되지 않음
                setCurrentConfigures((prev) => {
                  const updates: Partial<
                    type.ConfigObject & { max_consecutive_nights?: number }
                  > = {
                    three_seq_nig: isChecked,
                    max_consecutive_nights: isChecked ? 3 : 2,
                    // three_seq_nig 변경 시점에 둘 다 false로 완전 초기화
                    two_offs_after_three_nig: false,
                    two_offs_after_two_nig: false,
                  };

                  return {
                    ...prev,
                    ...updates,
                  };
                });
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>

        {three_seq_nig ? (
          <div className="conf_schedule__row conf_schedule__gridRow--switch">
            <div className="conf_schedule__optText">
              나이트 <span className="text-sig font-semibold">3회</span> 이후
              OFF 2회
            </div>
            <label className="conf_slideSwitch">
              <input
                type="checkbox"
                checked={two_offs_after_three_nig}
                onChange={(e) => {
                  const isChecked = e.currentTarget.checked;
                  // 종속: 3N OFF가 켜지면 2N OFF도 반드시 켜짐
                  // (3N OFF가 꺼지면 2N OFF도 같이 꺼짐)
                  setCurrentConfigures((prev) => ({
                    ...prev,
                    two_offs_after_three_nig: isChecked,
                    two_offs_after_two_nig: isChecked,
                  }));
                }}
              />
              <span className="conf_switchHandler"></span>
              <span className="conf_switchStatus">근무표에 적용</span>
            </label>
          </div>
        ) : (
          <div className="conf_schedule__row conf_schedule__gridRow--switch">
            <div className="conf_schedule__optText">
              나이트 <span className="text-sig font-semibold">2회</span> 이후
              OFF 2회
            </div>
            <label className="conf_slideSwitch">
              <input
                type="checkbox"
                checked={two_offs_after_two_nig}
                onChange={(e) => {
                  const isChecked = e.currentTarget.checked;
                  setCurrentConfigures((prev) => ({
                    ...prev,
                    two_offs_after_two_nig: isChecked,
                  }));
                }}
              />
              <span className="conf_switchHandler"></span>
              <span className="conf_switchStatus">근무표에 적용</span>
            </label>
          </div>
        )}

        <div className="conf_schedule__row conf_schedule__gridRow--switch">
          <div className="conf_schedule__optText">월 나이트 근무 횟수 15회</div>
          <label className="conf_slideSwitch">
            <input
              type="checkbox"
              checked={max_nig_per_month === 15}
              onChange={(e) => {
                const isChecked = e.currentTarget.checked;
                const newValue = isChecked ? 15 : 0;
                setCurrentConfigures((prev) => ({
                  ...prev,
                  max_nig_per_month: newValue,
                }));
              }}
            />
            <span className="conf_switchHandler"></span>
            <span className="conf_switchStatus">근무표에 적용</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default ConfSection_law;
